export default {
	unsupported_browser: {
		en: "Browser not supported",
		ar: "متصفح غير معتمد"
	},
	unsupported_browser_msg: {
		en: "The web browser you are using is not supported by Dubai Brokers web application. For better experience, we suggest that you use one of these browsers:",
		ar: "متصفح الويب الذي تستخدمه غير مدعوم من قبل تطبيق وسطاء دبي. للحصول على تجربة أفضل ، نقترح عليك استخدام أحد هذه المتصفحات"
	},
	payment_url: {
		en: "Payment URL",
		ar: "رابط الدفع",
	},
	copied: {
		en: "Copied",
		ar: "نسخ"
	},
	wrong_mobile_update_eida: {
		en: "Don’t have access to the above number ?",
		ar: "الا يمكنك الوصول لرقم الهاتف بالاعلى؟"
	},
	eida_send_otp_mobile_number: {
		en: "We have sent you an One Time password (OTP) to your number {0} which is registered with Emirates ID. If this number is not correct then please update it with Emirates ID",
		ar: "ارسلنا اليك رمز المرور {0}   للرقم المسجل لبطاقة الهوية. في حالة خطأ بالرقم يرجى تحديثه ببطاقه الهوية",
	},
	error_no_mobile: {
		en: "Error - No Mobile Number",
		ar: "خطأ – لايوجد رقم هاتف",
	},
	error_no_mobile_desc: {
		en: "As per our records, we did not find any mobile number to send the OTP for verification.",
		ar: "طبقا لسجلاتنا, لم نعثر على اي رقم هاتف لارسال رمز المرور للتحقق منه"
	},
	eida_update_nxt_step: {
		en: "You now can update your mobile number with us as per the records with Emirates Identity Authority.",
		ar: "يمكنك الان تحديث رقم هاتفك برقم الهاتف المسجل لبطاقة الهوية"
	},
	next_step: {
		en: "Next Step",
		ar: "الخطوة التالية",
	},
	update_profile: {
		en: "Update Profile",
		ar: "الملف الشخصى تحديث",
	},
	profile_update_success: {
		en: "Your profile has been updated successfully.",
		ar: "تم تحديث الملف الشخصى بنجاح",
	},
	dash_board: {
		en: "Dashboard",
		ar: "اللوحة الرئيسية",
	},
	internal_property_valuation: {
		en: "Internal Property Evaluation",
		ar: "تقييم عقار داخلى",
	},
	insurance_value: {
		en: "Insurance Value",
		ar: "قيمة التأمين",
	},
	claimant_defendant_detail_val: {
		en: "Claimant and Defendant details should not be the same.",
		ar: "بيانات المشتكى و المشتكي عليه يجب ان تكون مختلفة.",
	},
	ok: {
		en: "Ok",
		ar: "موافق",
	},
	invalid_link: {
		en: "Invalid Link",
		ar: "رابط غير صالح",
	},
	email_address_verified: {
		en: "Your email address verification is now complete",
		ar: "اكتملت عمليه التحقق من بريدك الالكتروني",
	},
	later: {
		en: "Later",
		ar: "لاحقا",
	},
	no_invalid_email: {
		en: "Please update your Email Address",
		ar: "يرجى تحديث بريدك الالكتروني",
	},
	unverified_email: {
		en: "Please verify your Email Address",
		ar: "يرجى التحقق من البريد الالكتروني",
	},
	email_update_info: {
		en: "Please update your email address for effective communication",
		ar: "يرجى تحديث بريدك الالكتروني لتواصل افضل",
	},
	email_verify_info: {
		en: "Please verify your email address for effective communication",
		ar: "يرجى التحقق من بريدك الالكتروني لتواصل افضل",
	},
	verify_email: {
		en: "Verify Email Address",
		ar: "تحقق من البريد الالكتروني",
	},
	will_send_verification_email: {
		en: "We will be sending verification email to your email address {0}",
		ar: "سنرسل بريد الكتروني للتحقق من بريدك الالكتروني{0}",
	},
	change_email: {
		en: "Change Email address",
		ar: "تغيير البريد الالكتروني",
	},
	verification_email_sent: {
		en: "We have sent verification email to your email address {0}. Please click on the link to verify",
		ar: "لقد ارسلنا رسالة بريد الكتروني للتحقق من بريدك الالكتروني {0}.يرجى الضغط على الرابط",
	},
	sending_verification: {
		en: "Sending Verification to your email address {0}",
		ar: "جاري ارسال رساله بريد الكتروني للتحقق من بريدك الالكتروني {0}",
	},
	mobile_number_updated: {
		en: "Your Mobile Number has been updated successfully",
		ar: "تم تحديث رقم هاتف المحمول الخاص بك بنجاح",
	},
	no_data_available: {
		en: "No data available",
		ar: "لا توجد بيانات",
	},
	dnrd_data_info: {
		en: "We were unable to locate your information based on your ~.",
		ar: "لم نتمكن من تحديد معلوماتك بناءً على ~.",
	},
	dnrd_mobile_info: {
		en: "Please update your mobile number with Emirates ID authority if below number is incorrect.",
		ar: "يرجى تحديث رقم هاتفك المحمول مع هيئة الإمارات للهوية إذا كان الرقم أدناه غير صحيح.",
	},
	worth_aed: {
		en: "Worth (in AED)",
		ar: "القيمة (بالدرهم)",
	},
	transaction_units: {
		en: "Unit/s",
		ar: "وحدات سكنية",
	},
	transaction_buildings: {
		en: "Building/s",
		ar: "مباني",
	},
	transaction_lands: {
		en: "Land/s",
		ar: "أراضي",
	},
	transaction_step_1_tile: {
		en: "Select Procedure Type",
		ar: "إختر نوع الإجراء",
	},
	transaction_step_1_desc: {
		en: "Select the Procedure Type to filter out the results.",
		ar: "إختر نوع الإجراء لتصفية النتائج.",
	},
	transaction_step_2_tile: {
		en: "Select the Period",
		ar: "إختر المدة الزمنية",
	},
	transaction_step_2_desc: {
		en: "You can choose the period either for a single day, week or can do a custom period search.",
		ar: "يمكنك إختيار المده كيوم واحد او كإسبوع او حتى مدة  زمنية أخرى من إختيارك.",
	},
	transaction_step_3_tile: {
		en: "Data Source",
		ar: "مصدر البيانات",
	},
	transaction_step_3_desc: {
		en: "Switch between Existing or Off-plan properties to view the details in the graph.",
		ar: "بدل بين العقارات المنجزة و العقارات على الخريطة  لعرض البيانات في الرسم البياني.",
	},
	transaction_step_4_tile: {
		en: "Custom graph",
		ar: "رسم بياني مخصص",
	},
	transaction_step_4_desc: {
		en: "Select a specific area on the graph to zoom into specific period. You can download the graph to view details.",
		ar: "حدد منطقة معينة على الرسم البياني لتتمكن من التكبير.يمكنك أيضا تنزيل الرسم البياني لعرض البيانات.",
	},
	download_sale_contract: {
		en: "Download Property Sale Contract",
		ar: "تنزيل عقد بيع العقار",
	},
	dld_vault: {
		en: "DLD Document Vault",
		ar: "مستودع مستندات هيئة دبي للأراضي و الأملاك",
	},
	vault_eg_ref: {
		en: "e.g: AP1234567890",
		ar: "AP1234567890 على سبيل المثال"
	},
	ref: {
		en: "Ref",
		ar: "رقم المرجع"
	},
	file_name: {
		en: "File Name",
		ar: "إسم الملف"
	},
	we_sent_otp_to_vault_owner: {
		en: "We have send the OTP to the vault owner",
		ar: "لقد أرسلنا رمز المرور لمالك مستودع الملفات"
	},
	please_enter_verification_code: {
		en: "Please enter verification code",
		ar: "يرجى ادخال رمز التحقق"
	},
	loading: {
		en: "Loading...",
		ar: "جاري التحميل..."
	},
	land_evaluation_accept_no_building_empty_land: {
		en: "I Accept that this is an empty land",
		ar: "أنا أقبل أن هذه أرض فارغة",
	},
	land_evaluation_accept_no_building_empty_land_info: {
		en: "In case of a Non-Empty Land, please visit Property Trustee Office to complete this transaction",
		ar: "في حالة وجود أرض غير فارغة ، يرجى زيارة مكتب الأمين العقاري لإتمام هذه المعاملة"
	},
	i_understand: {
		en: "I Understand",
		ar: "أوافق",
	},
	land_eval_popup_info: {
		en: "Kindly note that this service of Valuation Certificate is for an EMPTY LAND ONLY",
		ar: "يرجى ملاحظة أن خدمة شهادة التقييم مخصصة للأراضي الفارغة فقط",
	},
	locate_property_trustee_office: {
		en: "Locate Property Trustee Office",
		ar: "حدد موقع مكتب الأمين العقاري",
	},
	information: {
		en: "Information",
		ar: "معلومات",
	},
	verify_email_to_use_service: {
		en: "Please verify your e-mail address to use this service",
		ar: "يرجى التحقق من بريدك الإلكتروني لإستخدام هذه الخدمة"
	},
	verify_email_address: {
		en: "Verify email address",
		ar: "تحقق من البريد الإلكتروني"
	},
	view_remarks: {
		en: "View Remarks",
		ar: "عرض الملاحظات",
	},
	cancel: {
		en: "Cancel",
		ar: "إلغاء",
	},
	view_details: {
		en: "View Details",
		ar: "عرض المزيد",
	},
	select_all: {
		en: "Select All",
		ar: "اختر الكل",
	},
	un_select_all: {
		en: "Deselect All",
		ar: "الغاء تحديد الكل",
	},
	property_detail_certificate: {
		en: "Request for Detailed Property Certificate",
		ar: "طلب بيان عقار تفصيلي",
	},
	change_password: {
		en: "Change Password",
		ar: "تغيير كلمة المرور",
	},
	password_updated_msg: {
		en: "Your password has been updated successfully.",
		ar: "تم تحديث كلمةالمرور بنجاح",
	},
	filter_by: {
		en: "Filter by",
		ar: "مصنف بواسطة",
	},
	community_area: {
		en: "Community / Area",
		ar: "المجمع / المنطقة",
	},
	projects: {
		en: "Projects",
		ar: "المشاريع",
	},
	dp_today: {
		en: "Today",
		ar: "اليوم"
	},
	dp_yesterday: {
		en: "Yesterday",
		ar: "أمس"
	},
	dp_last_seven_days: {
		en: "Last 7 Days",
		ar: "قبل 7 أيام"
	},
	dp_last_th_days: {
		en: "Last 30 Days",
		ar: "آخر  30 يوما"
	},
	dp_this_month: {
		en: "This Month",
		ar: "هذا الشهر"
	},
	dp_last_month: {
		en: "Last Month",
		ar: "الشهر الماضي"
	},
	dp_custom_range: {
		en: "Custom Range",
		ar: "نطاق مخصص"
	},
	bcs_reclassification: {
		en: "Project Building Report Procedure (BCS)",
		ar: "إجراءات تقرير بناء المشروع (BCS)",
	},
	star_building_rating: {
		en: "Star Rating",
		ar: "تصنيف المبنى "
	},
	bcs_building_Survey_details: {
		en: "Building Survey Details",
		ar: "تفاصيل مسح المبنى",
	},
	re_valuate: {
		en: "Re-Evaluate",
		ar: "إعادة التقييم",
	},
	date_issued: {
		en: "Date Issued",
		ar: "تا يخ الإصدار",
	},
	bcs_contact_information_detail: {
		en: "This information will be used if site visit is required",
		ar: "سيتم استخدام هذه المعلومات إذا كانت زيارة الموقع مطلوبة",
	},
	download_certificate_details: {
		en: "Download Certificate Details",
		ar: "تحميل تفاصيل شهادة",
	},
	property_documents: {
		en: "Property Procedures, Receipts and Documents",
		ar: "الإجراءات و سندات القبض و مستندات العقار",
	},
	speak_now: {
		en: "Speak now",
		ar: "تكلم الآن",
	},
	view_all_property_documents: {
		en: "View All",
		ar: "عرض الكل"
	},
	procedure_number: {
		en: "Procedure Number",
		ar: "رقم الإجراء",
	},
	request_submitted_successfully_under_audit: {
		en: "Your request has been submitted successfully. It is under Dubai Land Department audit.",
		ar: "تم تقديم طلبك بنجاح. و تم إرساله للتدقيق لدائرة الأراضي والأملاك في دبي.",
	},
	req_pending_payment: {
		en: "Pending Payment",
		ar: "بانتظار الدفع",
	},
	req_paid: {
		en: "Paid",
		ar: "مدفوع",
	},
	req_completed: {
		en: "Completed",
		ar: "منجز",
	},
	req_rejected: {
		en: "Rejected",
		ar: "مرفوض",
	},
	req_cancelled: {
		en: "Cancelled",
		ar: "ملغى",
	},
	req_entered: {
		en: "Entered",
		ar: "مدخل",
	},
	req_new: {
		en: "New",
		ar: "جديد",
	},
	req_assigned: {
		en: "Assigned",
		ar: "تعيين",
	},
	req_under_audit: {
		en: "Under Auditing",
		ar: "قيد المراجعة",
	},
	reason_for_rejection: {
		en: "Reason for rejection",
		ar: "سبب الرفض",
	},
	no_property_photos_info: {
        en: "You have not added any photographs of this property.",
		ar: "لإضافة صور العقارات ، يرجى النقر فوق \"إضافة\"",
	},
	main: {
		en: "Main",
		ar: "الرئيسية",
	},
	set_as_main_photo: {
		en: "Set as a Main Photo",
		ar: "تعيين كصورة رئيسية",
	},
	selected: {
		en: "Selected",
		ar: "المحدد",
	},
	property_photo_delete_confirmation: {
		en: "Are you sure you want to delete this photo?",
		ar: "هل أنت متأكد أنك تريد مسح الصورة؟",
	},
	property_photo_upload_validation: {
		en: "Only file types with the extension .jpg and.png are allowed with a maximum file size of ~MB",
		ar: "يُسمح فقط بأنواع الملفات ذات الامتداد .jpg و.png بحد أقصى لحجم الملف ~ ميجابايت"
	},
	rental_range: {
		en: "Rental Range",
		ar: "نطاق التأجير",
	},
	property_drawing: {
		en: "Property Drawing",
		ar: "مخطط العقار",
	},
	view_image: {
		en: "View (Image)",
		ar: "عرض الصورة",
	},
	share_auto_cad: {
		en: "Share (AutoCAD)",
		ar: "مشاركة  ملف أوتوكاد",
	},
	autocad_file: {
		en: "AutoCAD File",
		ar: "ملف أوتوكاد",
	},
	image_file: {
		en: "Image File",
		ar: "ملف الصورة",
	},
	max_password_length_sixteen: {
		en: "Maximum 16 characters long",
		ar: "16 حرفا كحد أقصى"
	},
	send_receipt: {
		en: "Send Receipt",
		ar: "إرسال سند القبض",
	},
	view_more: {
		en: "View More",
		ar: "عرض المزيد",
	},
	view_less: {
		en: "View Less",
		ar: "عرض أقل",
	},
	add_photo: {
		en: "Add Photo",
		ar: "إضافة صورة",
	},
	receipt_sent_to_profile_email: {
		en: "The receipt is sent to your profile email address.",
		ar: "تم إرسال السند إلى البريد الإلكتروني المسجل",
	},
	selected_properties: {
		en: "Selected Properties",
		ar: "العقارات المختارة",
	},
	you_need_minimum_two_properties_for_this_procedure: {
		en: "You need minimum 2 properties for this procedure.",
		ar: "يجب إختيار عقارين أو أكثر.",
	},
	deselect_property: {
		en: "Deselect Property",
		ar: "حذف عقار",
	},
	select_property: {
		en: "Select Property",
		ar: "إختيار عقار",
	},
	add_remove_properties: {
		en: "Add / Remove Properties",
		ar: "إضافة / حذف عقارات"
	},
	add_more_properties: {
		en: "Add More Properties",
		ar: "أضف المزيد من العقارات",
	},
	please_select_from_below_properties: {
		en: "Please select from below Properties",
		ar: "الرجاء إختيار من العقارات أدناه",
	},
	co_occupant_details: {
		en: "Co-Occupant Details",
		ar: "تفاصيل بيانات القاطنين"
	},
	sr_no: {
		en: "Sr. No.",
		ar: "الرقم التسلسلي",
	},
	manage_co_occupants: {
		en: "Manage Co-Occupants",
		ar: "إدارة بيانات القاطنين",
	},
	add_co_occupant: {
		en: "Add Co-Occupant",
		ar: "أضف بيانات قاطن آخر",
	},
	emirates_id_of_co_occupant: {
		en: "Emirates ID of Co-Occupant",
		ar: "الهوية الإماراتية للقاطن ",
	},
	dob_of_co_occupant: {
		en: "Date of Birth of Co-Occupant",
		ar: "تاريخ ميلاد القاطن",
	},
	no_co_occupants_yet: {
		en: "You have not added any Co-Occupant yet.",
		ar: "لم تقم بإضافة أي بيانات للقاطنين حتى الآن",
	},
	co_occupants: {
		en: "Co-Occupants",
		ar: "بيانات القاطنين",
	},
	co_oc_tc: {
		en: "I hereby confirm that the information provided herein is genuine",
		ar: "بموجب هذا، أقرّ على أن المعلومات التي تم تقديمها صحيحة",
	},
	co_oc_del_confirm: {
		en: "Do you want to delete the Co-occupant?",
		ar: "هل ترغب في حذف بيانات القاطنين ؟",
	},
	co_oc_updated: {
		en: "Co-Occupants have been successfully updated on your contract",
		ar: "تمت تحديث القاطنين بنجاح إلى عقدك",
	},
	add_more_co_occupants: {
		en: "Add more Co-Occupants",
		ar: "أضف مزيد قاطن",
	},
	email_address: {
		en: "Email Address",
		ar: "عنوان البريد الكتروني",
	},
	registered_email: {
		en: "Registered email address",
		ar: "عنوان البريد الإلكتروني المسجل",
	},
	welcome_to_dubai_land_department_application_dashboard: {
		en: "Welcome to Dubai Land Department Application Dashboard",
		ar: "مرحبًا بكم في لوحة تحكم تطبيق دائرة الأراضي والأملاك في دبي"
	},
	want_to_know_more_about_each_application: {
		en: "Want to know more about each application.",
		ar: "هل تريد معرفة المزيد عن كل تطبيق؟",
	},
	click_here_caps: {
		en: "Click here",
		ar: "اضغط هنا",
	},
	enter_no_of_co_co_occupants: {
		en: "Enter number of Co Occupants",
		ar: " أدخل عدد القاطنين",
	},
	please_enter_number_of_co_occupants: {
		en: "Please enter number of Co Occupants",
		ar: " يرجى إدخال عدد القاطنين",
	},
	co_occupants_data_optional: {
		en: "Co Occupant's Data (optional)",
		ar: " بيانات القاطنين (اختياري)",
	},
	co_oc_number_updated: {
		en: "Co-Occupants has been successfully updated on your contract.",
		ar: " تم التحديث أعداد القاطنين في العقد الخاص بك بنجاح",
	},
	co_oc_number_updated_q: {
		en: "Do you want to enter their personal information? (Not mandatory)",
		ar: "هل تود إدخال بياناتهم الشخصية ؟ (اختياري)",
	},
	reg_a_business_user: {
		en: "a Business User",
		ar: "مستخدم الأعمال",
	},
	reg_an_individual: {
		en: "an Individual",
		ar: "الفرد",
	},
	mnu_login_help: {
		en: "Who is a business user and individual?",
		ar: "من هو مستخدم الأعمال والفرد؟",
	},
	login_as_business_user_via: {
		en: "Login as Business User",
		ar: "تسجيل الدخول كمستخدم أعمال من خلال",
	},
	login_as_business_user: {
		en: "Login as Business User",
		ar: "تسجيل الدخول كمستخدم أعمال",
	},
	login_as_individual: {
		en: "Login as an Individual",
		ar: "تسجيل الدخول كفرد",
	},
	login_as_individual_via: {
		en: "Login as an Individual via",
		ar: "تسجيل الدخول كفرد من خلال",
	},
	user_login: {
		en: "User Login",
		ar: "تسجيل دخول المستخدم",
	},
	register_individual_via: {
		en: "Register as an Individual via",
		ar: "سجل كفرد عبر",
	},
	personal_information: {
		en: "Personal Information",
		ar: "المعلومات الشخصية",
	},
	register_popup_info_1: {
		en: "If you are already an Owner of a Property, you do not need to register.",
		ar: "إذا كنت مالك عقار ، فلا داعي للتسجيل.",
	},
	register_popup_info_2: {
		en: "Please proceed to Login directly",
		ar: "يرجى تسجيل الدخول مباشرة",
	},
	eid_expired_date: {
		en: "Emirates Id Expired.",
		ar: "انتهت صلاحية هوية الإمارات.",
	},
	site_plan_download: {
		en: "Download Site Plan",
		ar: "تحميل مخطط الموقع",
	},
	site_plan_unavailable: {
		en: "Property site plan does not exist, please contact GIS department.",
		ar: "الملفات الهندسية للعقار غير موجودة, يرجى مراجعة موظفي قسمي المساحة والمخططات",
	},
	owner_company: {
		en: "Owner Company",
		ar: "شركة المالك",
	},
	my_self: {
		en: "My Self",
		ar: "شخصي",
	},
	duplicate_twimc_error_msg: {
		en: "This request already exists, if you want to modify the request, Please cancel existing request from \"My Requests\"",
		ar: "هذا الطلب موجود بالفعل، إذا كنت ترغب في تعديل الطلب ، فالرجاء إلغاء الطلب الحالي من خدمة \"طلباتي\"",
	},
	company_properties: {
		en: "Company Properties",
		ar: "عقارات الشركة",
	},

	sso_email_verification_needed: {
		en: "To enhance the security of your account, please verify your email address using the OTP code which will be sent to your email address ({0}).",
		ar: "لتعزيز أمان الحساب الخاص بك ، يرجى التحقق من عنوان بريدك الإلكتروني باستخدام رمز OTP الذي سيتم إرساله إلى عنوان بريدك الإلكتروني ({0}).",
	},
	sso_email_verification_needed_help: {
		en: "Please click on \"Receive OTP\" and then enter the code to complete the verification process.",
		ar: "يرجى الضغط فوق \"تلقي OTP\" ثم إدخال الرمز لإكمال عملية التحقق.",
	},
	receive_otp: {
		en: "Receive OTP",
		ar: "تلقي OTP",
	},
	retry: {
		en: "Retry",
		ar: "أعد المحاولة",
	},
	property_status: {
		en: "Property Status",
		ar: "حالة العقار",
	},
	send_otp_email: {
		en: "We have sent you an One Time password (OTP) to your email {0}.",
		ar: "لقد أرسلنا لك كلمة مرور صالحة لمرة واحدة  إلى بريدك الإلكتروني {0}",
	},
	we_have_sent_pass_code_to_your_registered_email_id: {
		en: "We have sent a passcode to your registered email address",
		ar: "لقد أرسلنا كلمة المرور إلى عنوان بريدك الإلكتروني المسجل",
	},
	forgot_password_info_email_otp: {
		en: "Please note that a OTP will be sent to your registered email for verification.",
		ar: "يرجى العلم أنه سيتم إرسال رمز التحقق OTP إلى بريدك الإلكتروني المسجل",
	},
	twimc_description: {
		en: "This service allows applying to issue a certificate of the customer's real estate statement.",
		ar: "تتيح هذه الخدمة للمتعاملين القيام بتسجيل طلب إصدار شهادة بيان أملاك المتعامل أو شهادة استيفاء بالمتطلبات الخاصة بإدارة العقارات.",
	},
	out_of: {
		en: "out of",
		ar: "من"
	},
	rating: {
		en: "Rating",
		ar: "التقييم",
	},
	dont_have_uae_pass_account: {
		en: "Don't have UAE PASS account ?",
		ar: "ليس لديك حساب الهوية الرقمية (UAE PASS) ؟",
	},
	create_new_account: {
		en: "Create new Account",
		ar: "أنشئ حساب جديد",
	},
	how_to_register_for_uae_pass: {
		en: "How to Register for UAE PASS ?",
		ar: "كيف أسجل (UAE Pass) ؟",
	},
	watch_video: {
		en: "Watch Video",
		ar: "شاهد الفيديو",
	},
	watch_video_link: {
		en: "https://www.youtube.com/watch?v=M62taRz58f0",
		ar: "https://www.youtube.com/watch?v=BKEZ_ydm_H8",
	},
	select_application: {
		en: "Select Application",
		ar: "اختار التطبيق",
	},
	multiple_profiles_found: {
		en: "Multiple Profiles Found",
		ar: "تم العثور على اكثر من ملف شخصى"
	},
	multiple_profiles_description: {
		en: "Based on your successful login, we found multiple profiles. kindly select a profile to proceed.",
		ar: "استنادًا إلى تسجيل الدخول الناجح الخاص بك، وجدنا ملفات شخصية متعددة. يرجى اختيار ملف"
	},
	proceed_to_application: {
		en: "Proceed to Application",
		ar: "المتابعة الى التطبيق"
	},
	username: {
		en: "Username",
		ar: "اسم المستخدم"
	},
	sso_login_with_uae_pass: {
		en: "Login with UAE Pass",
		ar: "الدخول بالهوية الرقمية"
	},
	yes_continue: {
		en: "Yes, Continue",
		ar: "اسم المستخدم"
	},
	need_uae_pass: {
		en: "You need to login via UAE PASS only to access this application.",
		ar: "يجب عليك تسجيل الدخول باستخدام الهوية الرقمية للوصول الى هذا التطبيق"
	},
	stay_dashboard: {
		en: "Stay on Dashboard",
		ar: "البقاء على اللوحة الرئيسية"
	},
	profile: {
		en: "Profile",
		ar: "الملف الشخصي"
	},
	i_agree: {
		en: "I Agree",
		ar: "أنا موافق"
	},
	multiple_profile_Desc: {
		en: "We have found your profile in multiple companies. Kindly fill in your designation in each company on the non disclosure agreement (NDA) form.",
		ar: "لقد وجدنا ملفك الشخصي في العديد من الشركات. يرجى ملء تعيينك في كل شركة في نموذج اتفاقية عدم الإفصاح (NDA)."
	},
	enter_designation: {
		en: "Enter Designation",
		ar: "أدخل التعيين"
	},
	enter_company_name: {
		en: "Enter Company Name",
		ar: "أدخل اسم الشركة"
	},
	single_profile_Desc: {
		en: "We have found your profile in a company. Kindly fill in your designation on the non disclosure agreement (NDA) form.",
		ar: "لقد وجدنا ملفك الشخصي في شركة. يرجى ملء تعيينك في نموذج اتفاقية عدم الإفصاح (NDA)."
	},
	required: {
		en: "Required",
		ar: "مطلوب"
	},
	designation_en: {
		en: "Designation (EN)",
		ar: ""
	},
	designation_ar: {
		en: "Designation (AR)",
		ar: ""
	},
	company_name_en: {
		en: "Company Name (EN)",
		ar: ""
	},
	company_name_ar: {
		en: "Company Name (AR)",
		ar: ""
	},
	please_enter_valid_unified_number: {
		en: "Please enter a valid Unified Number",
		ar: "الرجاء إدخال الرقم الموحد ساري المفعول",
	},
	please_enter_valid_residence_visa_number: {
		en: "Please enter a valid Residence Visa Number",
		ar: "الرجاء إدخال رقم تأشيرة الإقامة سارية المفعول",
	},
	please_enter_valid_eid: {
		en: "Please enter a valid Emirates ID",
		ar: "الرجاء إدخال بطاقة هوية إماراتية سارية المفعول",
	},
	please_enter_dob: {
		en: "Please enter a valid date of birth",
		ar: "الرجاء إدخال تاريخ الميلاد بشكل صحيح",
	},
	please_enter_valid_phone_number: {
		en: "Please enter a valid phone number",
		ar: "الرجاء إدخال رقم الهاتف بشكل صحيح",
	},
	please_enter_valid_email: {
		en: "Please enter a valid email address",
		ar: "الرجاء إدخال عنوان بريد إلكتروني فعال",
	},
	please_enter_valid_certificate_no: {
		en: "Please enter a valid Certificate Number",
		ar: "الرجاء إدخال رقم شهادة ساري المفعول",
	},
	please_enter_valid_issue_date: {
		en: "Please enter a valid Issue Date",
		ar: "الرجاء إدخال تاريخ الإصدار ساري المفعول",
	},
	please_enter_valid_owner_number_name: {
		en: "Please enter a valid Owner Participant No. / Name",
		ar: "الرجاء إدخال رقم / اسم المالك المشارك بشكل صحيح",
	},
	please_select_property_type: {
		en: "Please select property type",
		ar: "يرجى اختيار نوع العقار",
	},
	property_services: {
		en: "Property Services",
		ar: "الخدمات العقارية"
	},
	kyc_update_required: {
		en: "KYC Update required",
		ar: "يجب تحديث بيانات اعرف عميلك (KYC)",
	},
	kyc_update_description: {
		en: "Your KYC is not updated as per UAE PASS. For uninterrupted use of all your property related services, you need to update your KYC. You can still use general services offered by Dubai Land Department.",
		ar: "لم يتم تحديث بيانات اعرف عميلك (KYC) وفقًا لمتطلبات الهوية الرقمية. لاستمرار استخدام جميع خدماتك العقارية دون انقطاع، يجب عليك تحديث هذه البيانات. لا يزال بإمكانك استخدام الخدمات العامة التي تقدمها دائرة الأراضي والأملاك في دبي."
	},
	kyc_update_description_2: {
		en: "According to our records, your details are not up to date. We will update the personal information which registered with UAE PASS.",
		ar: "سيتم تحديث بياناتك الشخصية المسجلة لدينا عن طريق البيانات الموجودة في الهوية الرقمية",
	},
	kyc_update_successfully: {
		en: "KYC Updated Successfully",
		ar: "تم تحديث بيانات اعرف عميلك (KYC)",
	},
	kyc_update_description_3: {
		en: "Your KYC has been updated successfully. You can now use all property related services offered by Dubai Land Department",
		ar: "تم تحديث بيانات اعرف عميلك (KYC). يمكنك استخدام جميع الخدمات العقارية التي تقدمها دائرة الأراضي والأملاك في دبي",
	},
	your_kyc_updated: {
		en: "Your KYC has been updated successfully",
		ar: "تم تحديث بيانات اعرف عميلك (KYC)",
	},
	update_via_usepass: {
		en: "Update via UAE PASS",
		ar: "تحديث عن طريق الهوية الرقمية",
	},
	update_via_usepass_confirmation: {
		en: "Please proceed to login with UAE Pass to update your profile details.",
		ar: "يرجى تسجيل الدخول باستخدام الهوية الرقمية لتحديث بيانات ملفك الشخصي.",
	},
	change_of_property_type: {
		en: "Change Of Property Type",
		ar: "تغيير نوع العقار",
	},
	plot_no: {
		en: "Plot No. ",
		ar: "رقم الأرض",
	},
	area_name: {
		en: "Area Name",
		ar: "اسم المنطقة",
	},
	important_info: {
		en: "Important information regarding your property",
		ar: "يمكن تحويل هذا العقار الان الى تملك حر",
	},
	transfer_property: {
		en: "This property can now be converted to \"FREEHOLD\"",
		ar: "يمكن الآن نقل هذا العقار باعتباره \"تملك حر\"",
	},
	view_property: {
		en: "View Property ",
		ar: "عرض التفاصيل",
	},
	dear_customer: {
		en: "Dear Customer,",
		ar: "عزيزي المتعامل,"
	},
	dear_customer_message: {
		en: "We are pleased to inform you that following Lands owned by you are convertible to \"FREEHOLD\" ownership. If you wish to transfer, please contact the Land Department via email: ",
		ar: " يسرنا اعلامكم بأن الأراضي التالية المملوكة لكم قابلة للتحويل إلى \"تملك حر\". في حال رغبتكم في التحويل يرجى التواصل مع دائرة الأراضي والأملاك عبر البريد الإلكتروني: ",
	},
	not_applicable: {
		en: "N/A",
		ar: "لا ينطبق",
	},
	is_property_blocked: {
		en: "Is the property blocked?",
		ar: "هل العقار محجوز؟",
	},
	not_applicable_1: {
		en: "N/A",
		ar: "لا ينطبق",
	},
	first_time_buyer: {
		en: "First Time Home Buyer in Dubai?",
		ar: "هل هي اول مرة للشراء في دبي في مناطق الامتلاك الحر؟",
	},
	first_time_buyer_desc: {
		en: "Register your interest & connect to approved developers in Dubai",
		ar: "سجل في قائمة الاهتمام و قم بالتواصل مع المطورين العقاريين في دبي",
	},
	eligibility_criteria: {
		en: "Eligibility Criteria",
		ar: "معايير الأهلية",
	},
	eligibility_criteria_1_title: {
		en: "First freehold property to be purchased",
		ar: "شراء أول عقار في مناطق الامتلاك الحر",
	},
	eligibility_criteria_1_desc: {
		en: "Applicants must not currently own a freehold residential property in Dubai.",
		ar: "مقدم الطلب لابد أن لايمتلك حالياً أي عقار في مناطق الامتلاك الحر في دبي",
	},
	eligibility_criteria_2_title: {
		en: "For everyone living in the UAE",
		ar: "لكل مقيم في دولة الإمارات العربية المتحدة",
	},
	eligibility_criteria_2_desc: {
		en: "Applicants can be a UAE national or an expat of any nationality but living in the UAE.",
		ar: "مقدم الطلب من الممكن أن يكون من مواطني الدولة او وافد من أي جنسية ومقيم في الدولة",
	},
	eligibility_criteria_3_title: {
		en: "For all income levels",
		ar: "لكل فئات الدخل",
	},
	eligibility_criteria_3_desc: {
		en: "Applicants can be in any income bracket.",
		ar: "مقدم الطلب من الممكن ان يكون في أي فئة من فئات الدخل",
	},
	eligibility_criteria_4_title: {
		en: "Minimum Age",
		ar: "الحد الأدنى للعمر",
	},
	eligibility_criteria_4_desc: {
		en: "The applicant must be at least 18 years old.",
		ar: "مقدم الطلب لابد ان يكون عمره 18 عام على الأقل",
	},
	eligibility_criteria_5_desc: {
		en: "Target property",
		ar: "العقار المستهدف",
	},
	eligibility_criteria_5_title: {
		en: "First freehold property to be purchased",
		ar: "شراء أول عقار في مناطق الامتلاك الحر",
	},
	you_benefit: {
		en: "You will benefit from …",
		ar: "سوف تستفيد من .....",
	},
	benefit_1: {
		en: "Early access to property launches & existing inventory",
		ar: "الوصول المبكر للعقارات الجديدة والحالية",
	},
	benefit_2: {
		en: "Special discounts",
		ar: "خصم خاص",
	},
	benefit_3: {
		en: "Relaxed payment of registration fees",
		ar: "دفع ميسر لرسوم التسجيل",
	},
	benefit_4: {
		en: "Residency assistance office access",
		ar: "الوصول لمكتب مساعدة الاقامة",
	},
	benefit_5: {
		en: "Among many others services and benefits",
		ar: "ومنافع اخري كثيرة ومميزات",
	},
	fthb_request_submitted: {
		en: "Your request for \"First Time Home Buyer\" has been submitted successfully !",
		ar: "طلبك فى \"شراء العقار الأول\" تم تسجيلة بنجاح",
	},
	can_now_share: {
		en: "You can now share this QR Code with Brokers and Real Estate Developers.",
		ar: "يمكنك الآن مشاركة رمز الاستجابة السريع مع الوسطاء والمطورين",
	},
	after_reviewing: {
		en: " After reviewing your details, we regret to inform you that you are currently not eligible to benefit from this initiative.",
		ar: "بعد مراجعة بياناتك, يؤسفنا ان نخبرك انك حاليا غير مؤهل للتقديم فى المبادرة",
	},
	not_eligible: {
		en: "You are not eligible",
		ar: "انت غير مؤهل",
	},
	opt_out_fthb: {
		en: "I would like to opt out from the \"First Time Home Buyer\" Service",
		ar: "ارغب فى عدم التسجيل فى برنامج \"شراء العقار الأول\"",
	},
	view_preferences: {
		en: "View Preferences",
		ar: "مشاهدة الخيارات",
	},
	property_preferences: {
		en: "Property Preferences",
		ar: "خيارات العقار",
	},
	mode_of_communication: {
		en: "Mode of Communication",
		ar: "طريقة التواصل",
	},
	residency_ques: {
		en: "When did you obtain your residency in the UAE?",
		ar: "متى حصلت على الاقامة فى دولة الإمارات العربية المتحدة؟",
	},
	current_employment_ques: {
		en: "What is your current employment status?",
		ar: "ماهى حالتك الوظيفية الآن؟",
	},
	preferred_property_ques: {
		en: "What is your preferred choice of property?",
		ar: "ماهى خيارات التفضيلية للعقار؟",
	},
	bedroom_ques: {
		en: "How many bedrooms are you looking for?",
		ar: "كم عدد الغرف؟",
	},
	budget_ques: {
		en: "What is your approximate budget?",
		ar: "ماهى ميزانيتك تقريبا؟",
	},
	preferred_developer_ques: {
		en: "Your preferred choice of developer",
		ar: "ماهى خياراتك للمطورين؟",
	},
	select_all_developers: {
		en: "Please select all the developers who you wish to be contacted by",
		ar: "الرجاء اختيار كل المطورين الذين ترغب فى تواصلهم معك",
	},
	preferred_communication_ques: {
		en: "Preferred mode of communication for the Developers",
		ar: "طريقة التواصل المفضلة مع المطورين",
	},
	submitting_terms: {
        en: "I affirm that the information provided is accurate to the best of my knowledge",
        ar: "اتعهد بأن بيانات المتعامل صحيحة حسب علمى",
	},
	view_edit_preferences: {
		en: "View/Edit Preferences",
		ar: "عرض/تحديث الخيارات",
	},
	view_qr_code: {
		en: "View QR Code",
		ar: "عرض رمز الاستجابة السريعة",
	},
	de_register_fthb: {
		en: "De-register from the program",
		ar: "عدم التسجيل فى المبادرة",
	},
	register_fthb: {
		en: "Register in the program",
		ar: "التسجيل فى المبادرة",
	},
	update_preferences: {
		en: "Update Preferences",
		ar: "تعديل الخيارات",
	},
	deregister_fthb_confirm: {
		en: "De-register from the Program?",
		ar: "عدم التسجيل فى المبادرة",
	},
	deregister_fthb_desc_1: {
		en: "Are you sure you want to de-register from the First Time Home Buyer program?",
		ar: "هل أنت متأكد من رغبتك فى عدم التسجيل فى مبادرة شراء العقار الأول؟",
	},
	deregister_fthb_desc_2: {
		en: "You will lose all your entered preferences and associated brokers (if any). You can register again at a later date",
		ar: "سوف تفقد كل البيانات الخاصة بك وكل البيانات بخصوص الوسطاء (إن وجدت), ولكن يمكنك التسجيل من جديد لاحقاً",
	},
	fthb_mandatory: {
		en: "Please select all mandatory information.",
		ar: "الرجاء اختيار كل الحقول المطلوبة",
	},
	image_saved_to_gallery: {
		en: "Image saved to photos gallery.",
		ar: "تم حفظ الصورة الى سجل الصور",
	},
	frequently_asked_ques: {
		en: "Frequently Asked Questions",
		ar: "الاسئلة الشائعة",
	},
	residency_status: {
		en: "Residency Status",
		ar: "حالة الإقامة",
	},
	view_update_preferences: {
		en: "View/Update Preferences",
		ar: "عرض/تحديث الخيارات",
	},
	manage_preferences: {
		en: "Manage your property preferences via your profile.",
		ar: "ادارة خياراتك العقارية عن طريق حسابك",
	},
	dear_user: {
		en: "Dear",
		ar: "عزيزي/عزيزتى",
	},
	thanks_for_interest: {
		en: "Thank you for your interest in the First-Time Home Buyer Initiative.",
		ar: "شكراً لاهتمامكم فى مبادرة شراء العقار الأول",
	},
	first_time_home_buyer: {
		en: "First Time Home Buyer",
		ar: "مبادرة شراء العقار الأول",
    },
    hb_faq_q01: {
        en: "What is the Dubai First-Time Home Buyer Program?",
        ar: "ما هو برنامج مشتري المنزل لأوّل مرة في دبي؟",
    },
    hb_faq_q02: {
        en: "Who is eligible for the program?",
        ar: "من هم الأفراد المؤهلين للتقدّم بطلب الانضمام إلى هذا البرنامج؟ ",
    },
    hb_faq_q03: {
        en: "What benefits do first-time buyers receive?",
        ar: "ما الفوائد التي يقدّمها البرنامج لمشتري المنزل لأوّل مرة؟ ",
    },
    hb_faq_q04: {
        en: "How do I apply for the program?",
        ar: "كيف أتقدّم بطلب للمشاركة في البرنامج؟",
    },
    hb_faq_q05: {
        en: "Who are the partner developers for the Program?",
        ar: "من هم المطوّرون العقاريون المشاركون في البرنامج؟",
    },
    hb_faq_q06: {
        en: "Who are the partner banks for the Program?",
        ar: "من هي البنوك المشاركة في البرنامج؟",
    },
    hb_faq_q07: {
        en: "Can I participate if I already own property in another Emirate?",
        ar: "هل يمكنني المشاركة في البرنامج إذا كنت أملك عقاراً في إمارة أخرى؟",
    },
    hb_faq_q08: {
        en: "Can I participate if I already own property in a non-freehold location?",
        ar: "هل يمكنني المشاركة في البرنامج إذا كنت أملك عقاراً في موقع تملّك غير حر؟",
    },
    hb_faq_q09: {
        en: "Do I need a mortgage to participate?",
        ar: "هل أحتاج إلى قرض عقاري للمشاركة في البرنامج؟",
    },
    hb_faq_q10: {
        en: "How will developers will reach out to eligible first-time home buyers in the program?",
        ar: "كيف سيتواصل المطوّرون العقاريون مع مشتري المنزل لأوّل مرة المؤهلين في البرنامج؟",
    },
    hb_faq_q11: {
        en: "How can I benefit from the improved access to mortgages through the program?",
        ar: "كيف يمكنني الاستفادة من فرصة الحصول على القروض العقارية من خلال البرنامج؟",
    },
    hb_faq_q12: {
        en: "What happens if I register but don’t find a property I like",
        ar: "ماذا سيحدث إذا قمت بالتسجيل في البرنامج ولم أجد العقار الذي يعجبني؟",
    },
    hb_faq_q13: {
        en: "Will I be eligible to benefit from the program again after selling the property which was bought through this program?",
        ar: "هل سأكون مؤهّلاً للاستفادة من البرنامج مرةً أخرى بعد بيع العقار الذي اشتريته من خلاله؟",
    },
    hb_faq_q14: {
        en: "Will I be able to jointly purchase a property through this program with someone who is not eligible?",
        ar: "هل سأتمكن من شراء العقار بشكل مشترك من خلال هذا البرنامج مع شخص غير مسجل في البرنامج؟",
    },
    hb_faq_a01: {
        en: "The Dubai First-Time Home Buyer Program is an initiative designed to support first-time buyers in purchasing their first property in Dubai. The program offers prioritized access to new property launches, special discounts on sale price, and improved mortgage options in partnership with top developers, real estate brokers, and banks.",
        ar: "يُعتبر برنامج مشتري المنزل لأوّل مرة في دبي مبادرة مميّزة تهدف إلى دعم الأفراد في شراء أول منزل لهم في الإمارة. يوفّر البرنامج أولوية الوصول إلى عروض العقارات الجديدة، ويمنح خصومات حصرية على أسعار البيع، بالإضافة إلى قروض عقارية ميسّرة، بالتعاون مع أبرز المطوّرين العقاريين، الوسطاء، والبنوك المحلية.",
    },
    hb_faq_a02_1: {
        en: "To qualify, applicants must meet the following criteria:",
        ar: "للتقدّم بطلب للانضمام إلى هذا البرنامج، يجب على المتقدِّمين استيفاء المعايير التالية:",
    },
    hb_faq_a02_2: {
        en: "Must be a UAE resident (national or expat).",
        ar: "يجب أن يكون المتقدِّم مقيماً في دولة الإمارات العربية المتحدة (مواطناً أو وافداً).",
    },
    hb_faq_a02_3: {
        en: "Must not currently own any freehold residential property in Dubai.",
        ar: "لا يجوز أن يكون المتقدِّم مالكاً حالياً لأي عقار سكني بتملّك حر في دبي.",
    },
    hb_faq_a02_4: {
        en: "Must be 18 years or older.",
        ar: "يجب أن يكون عمره 18 عاماً وما فوق.",
    },
    hb_faq_a02_5: {
        en: "Seeks a property which is below AED 5M in value.",
        ar: "يجب أن يبحث عن عقار قيمته تقلّ عن 5 ملايين درهم.",
    },
    hb_faq_a03_1: {
        en: "Eligible buyers will receive:",
        ar: "سوف يحصل المشترون المؤهلون على:",
    },
    hb_faq_a03_2: {
        en: "Priority access to units in new launches by participating developers.",
        ar: "أولوية الإطلاع وحجز الوحدات السكنية الجديدة التي يقدِّمها المطوّرون العقاريون المشاركون في هذا البرنامج.",
    },
    hb_faq_a03_3: {
        en: "Special discounts on sale price of off plan units.",
        ar: "خصومات حصرية على أسعار بيع الوحدات السكنية على المخطط.",
    },
    hb_faq_a03_4: {
        en: "Flexible payment plans on off plan properties.",
        ar: "خطط دفع مرنة للعقارات على المخطط.",
    },
    hb_faq_a03_5: {
        en: "Relaxed payment plans for DLD registration fees through eligible credits cards as part of interest-free plans.",
        ar: "خطط دفع ميسَّرة لرسوم التسجيل في دائرة الأراضي والأملاك عبر بطاقات ائتمان معتمدة، ضمن برامج تقسيط بدون فوائد.",
    },
    hb_faq_a03_6: {
        en: "Improved access to mortgages with better interest rates and reduced fees by participating banks.",
        ar: "تعزيز فرص الحصول على القروض العقارية بأسعار فائدة تنافسية ورسوم مخفّضة من البنوك المشاركة.",
    },
    hb_faq_a03_7: {
        en: "Automatic eligibility checks for residency programmes.",
        ar: "إجراء تحقُّق تلقائي من الأهلية لبرامج الإقامة المرتبطة بتملّك العقار.",
    },
    hb_faq_a03_8: {
        en: "Other additional offering by developers and banks.",
        ar: "الاستفادة من عروض إضافية مميزة يقدّمها المطوّرون العقاريون والبنوك المشاركة.",
    },
    hb_faq_a04_1: {
        en: "Register on the DLD website or through the Dubai REST app",
        ar: "سجّل عبر موقع دائرة الأراضي والأملاك في دبي أو من خلال تطبي \"دبي ريست\"",
    },
    hb_faq_a04_2: {
        en: "Submit the required information and documents.",
        ar: "قم بإرسال المعلومات المطلوبة وحدّد تفضيلاتك.",
    },
    hb_faq_a04_3: {
        en: "If eligible, you will receive a confirmation email from DLD containing your First Time Home Buyer QR code",
        ar: "إذا كنت مؤهلاً للمشاركة في البرنامج، ستتلقى رسالة تأكيد عبر البريد الإلكتروني من دائرة الأراضي والأملاك في دبي تحتوي على رمز الاستجابة السريعة (QR) الخاص بمشتري المنزل لأوّل مرة، بالإضافة إلى روابط لصفحات الويب الخاصة بالبنوك المشاركة",
    },
    hb_faq_a04_4: {
        en: "Access programme benefits through participating developers and banks",
        ar: "استفد من مزايا البرنامج عبر المطوّرين العقاريين والبنوك المشاركة",
    },
    hb_faq_a05_1: {
        en: "Azizi Developments",
        ar: "عزيزي للتطوير العقاري",
    },
    hb_faq_a05_2: {
        en: "Binghatti Properties",
        ar: "عزيزي للتطوير العقاري",
    },
    hb_faq_a05_3: {
        en: "DAMAC Properties",
        ar: "شركة داماك للتطوير العقاري",
    },
    hb_faq_a05_4: {
        en: "Danube Properties",
        ar: "شركة دانوب العقارية",
    },
    hb_faq_a05_5: {
        en: "Dubai Properties",
        ar: "مجموعة دبي للعقارات",
    },
    hb_faq_a05_6: {
        en: "Ellington Properties",
        ar: "شركة إلينغتون العقارية",
    },
    hb_faq_a05_7: {
        en: "EMAAR",
        ar: "شركة إعمار العقارية",
    },
    hb_faq_a05_8: {
        en: "Majid Al Futtaim",
        ar: "مجموعة ماجد الفطيم",
    },
    hb_faq_a05_9: {
        en: "Meraas",
        ar: "شركة مِراس",
    },
    hb_faq_a05_10: {
        en: "Nakheel Properties",
        ar: "شركة نخيل للتطوير العقاري",
    },
    hb_faq_a05_11: {
        en: "Beyond Developments",
        ar: "شركة بيوند للتطوير العقاري",
    },
    hb_faq_a05_12: {
        en: "Palma Holding",
        ar: "شركة بالما القابضة",
    },
    hb_faq_a05_13: {
        en: "Wasl",
        ar: "شركة وصل للعقارات",
    },
    hb_faq_a06_1: {
        en: "Commercial Bank of Dubai",
        ar: "بنك دبي التجاري",
    },
    hb_faq_a06_2: {
        en: "Dubai Islamic Bank",
        ar: "بنك دبي الإسلامي",
    },
    hb_faq_a06_3: {
        en: "Emirates NBD",
        ar: "بنك الإمارات دبي الوطني",
    },
    hb_faq_a06_4: {
        en: "Emirates Islamic",
        ar: "الإمارات الإسلامي",
    },
    hb_faq_a06_5: {
        en: "Mashreq Bank",
        ar: "بنك المشرق",
    },
    hb_faq_a07: {
        en: "Yes, as long as you do not currently own any freehold property in Dubai",
        ar: "نعم، يمكنك المشاركة طالما أنك لا تملك حاليّاً أي عقار بتملّك حر في دبي ",
    },
    hb_faq_a08: {
        en: "Yes, as long as you do not currently own any freehold property in Dubai",
        ar: "نعم، يمكنك المشاركة طالما أنك لا تملك حاليّاً أي عقار بتملّك حر في دبي",
    },
    hb_faq_a09: {
        en: "No, but special mortgage products with preferential interest rates and faster approval processes will be available to first-time buyers through partner banks.",
        ar: "كلا، ولكن ستتوفر قروض عقارية خاصة بأسعار فائدة مخفضة وعمليات موافقة أسرع للمشترين لأوّل مرة من خلال البنوك المشاركة.",
    },
    hb_faq_a10: {
        en: "Following the successful registration of the first-time buyer in the program, the selected developers will begin contacting eligible customers ahead of each real estate project launch.",
        ar: "بعد تسجيل المشتري لأول مرة في البرنامج بنجاح، سيبدأ المطوّرون العقاريون المختارون بالتواصل مع العملاء المؤهلين قبل إطلاق كل مشروع عقاري.",
    },
    hb_faq_a11: {
        en: "Following successful registration in the program, eligible first-time buyers may reach out to participating banks to take advantage of the program’s offerings.",
        ar: "بعد التسجيل الناجح في البرنامج، يمكن للمشترين لأول مرة المؤهلين التواصل مع البنوك المشاركة للاستفادة من عروض البرنامج.",
    },
    hb_faq_a12: {
        en: "Your registration remains valid, and you will continue to receive priority notifications for new launches throughout the program period.",
        ar: "يظل تسجيلك ساريّاً، وستستمر في تلقي إشعارات الأولوية للعقارات الجديدة طوال فترة مشاركتك في البرنامج.",
    },
    hb_faq_a13: {
        en: "Once you purchase a property, you will lose your First-Time Buyer status and cannot participate again even if you sell your property.",
        ar: "يبمجرَّد شراء العقار، ستفقد صفة \"المشتري لأول مرة\" ولن تتمكَّن من المشاركة في البرنامج مرة أخرى، حتى في حال بيع العقار.",
    },
    hb_faq_a14: {
        en: "No, joint property purchases through this program are only allowed between individuals who are both eligible.",
        ar: "كلا، يُسمح بشراء العقارات بشكل مشترك ضمن هذا البرنامج فقط بين الأفراد المؤهلين.",
    },
	please_select: {
		en: "Please Select",
		ar: "الرجاء التحديد",
	},
	eligibility_and_benefits: {
		en: "Eligibility and Benefits",
		ar: "الاستحقاقية والاستفادة",
	},
	visit_website: {
		en: "Visit Website",
		ar: "زيارة الموقع",
	},
	you_can_now_share_this_QR_code: {
		en: "You can now share this QR code with Brokers and Developers.  Manage your property preferences directly in your profile.",
		ar:"يمكنك الآن مشاركة رمز الاستجابة هذا مع الوسطاء العقاريين والبنوك وشركات التطوير العقاري. يمكنكم إدارة حسابكم وخياراتكم عن طريق ملفك الشخصي",
	},
	edit_preferences: {
		en: "Edit preferences",
		ar: "تحديث التفضيلات",
	},
	request_number_fthb: {
		en: "Request Number : ",
		ar: "رقم الطلب",
	},
	auto_renew: {
		en: "Auto Renew",
		ar: "",
	},
	selected_application: {
		en: "Selected Application",
		ar: "",
	},
	please_select_certificate_type: {
		en: "Please select certificate type",
		ar: "يرجى إختيار نوع الشهادة",
	},
	please_enter_certificate_number: {
		en: "Please enter a valid certificate no",
		ar: "يرجى إدخال رقم الشهادة صحيح",
	},
	please_enter_certificate_year: {
		en: "Please enter a Certificate Year",
		ar: "يرجى إدخال رقم سنة الشهادة",
	},
	please_enter_valid_email_address: {
		en: "Please enter a valid email address",
		ar: "يرجى إدخال بريدك الالكتروني صحيح",
	},
	please_enter_receipt_number: {
		en: "Please enter receipt number",
		ar: "يرجى إدخال رقم سند القبض",
	},
	please_enter_receipt_year: {
		en: "Please enter receipt year",
		ar: "يرجى إدخال سنة السند",
	}
};
